import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const K = {
  HostHortusBox: 'hortusbox',
  HostVPaceschi: 'vpaceschi',
  HostLeroyMerlin: 'leroymerlin',
  HostJardiland: 'jardiland'
}

const partners = {
  [K.HostHortusBox]: {
    id: '60a58efc70827f06f8725447'
  },
  [K.HostLeroyMerlin]: {
    id: '60a58f0e70827f06f8725448'
  },
  [K.HostVPaceschi]: {
    id: '60a58f2570827f06f8725449'
  },
  [K.HostJardiland]: {
    id: '611d74fc213b957e85a49009'
  }
}

const styles = {
  default: {
    logo: '/gimc/storage/assets/Logo_vert_RVB.png',
    name: 'HortusBox',
  },
  [K.HostLeroyMerlin]: {
    logo: '/gimc/storage/assets/LM&HB-02.png',
    name: 'Leroy Merlin'
  },
  [K.HostJardiland]: {
    logo: '/gimc/storage/assets/jardiland_hortusbox.png',
    name: 'Jardiland'
  }
}

const homes = {
  default: {
    sectionTwo: {
      description: 'Une communauté de paysagistes passionnés pour dessiner le jardin de vos rêves en fonction de votre style et de vos envies.'
    },
    ccm: {
      title: 'Comment ça marche ?',
      tile1: { description: 'Je choisis mon style en répondant à quelques questions.' },
      tile2: { description: 'J’importe le plan et les photos de mon espace.' },
      tile3: { description: 'Le paysagiste m’envoie une proposition d’aménagement et la liste des composants pour le réaliser.' },
      tile4: { description: 'J’achète les articles correspondants et je réalise mon projet d’aménagement.' }
    },
    todo: {
      tile1: { description: 'Un plan d’aménagement et des visuels 3D de mon espace.' },
      tile2: { description: 'La liste de toutes les plantes, mobiliers, accessoires pour réaliser mon jardin.' },
      tile3: { description: 'Un patron de plantation pour m’aider à planter sans me planter.' },
      tile4: { description: 'Des alertes d’entretien pour assurer le bien être de mes plantes.<br/><i>*Comin Soon</i>' }
    },
    commit: {
      title: 'HortusBox s\'engage',
      tile1: { title: 'Gain d\'argent'  , description: 'Transformez votre espace extérieur sans exploser votre budget.' },
      tile2: { title: 'Gain de temps'   , description: 'Réalisez le jardin de vos rêves sans bouger de chez vous.' },
      tile3: { title: 'Rendu réel'      , description: 'Projetez-vous dans votre jardin avant de dépenser.' },
      tile4: { title: 'Personnalisation', description: 'Votre style, vos envies et notre expertise.' }
    }
  },
  [K.HostLeroyMerlin]: {
    sectionTwo: {
      description: 'Un paysagiste vous accompagne dans la conception de votre projet d\'aménagement extérieur. Une shopping list ainsi qu’un plan de plantation vous seront fournis, pour réaliser le jardin de vos rêves par vous-même. Vous trouverez les articles de votre shopping list chez Leroy Merlin.'
    },
    ccm: {
      title: 'Mon projet en 4 étapes',
      tile1: { description: 'Je choisis mon style en répondant à quelques questions.' },
      tile2: { description: 'J’envoie mon plan de masse et des photos suivant le guide HortusBox.' },
      tile3: { description: 'Je reçois mon HortusBook avec les photos avant-après 3D, la shopping list et le plan de plantation.' },
      tile4: { description: 'Je concrétise mon projet grâce à la shopping-list et je bénéficie d’offres exclusives chez Leroy Merlin.' }
    },
    todo: {
      tile1: { description: 'Plusieurs visuels avant-après en 3D de votre espace extérieur.' },
      tile2: { description: 'La liste exhaustive de tous les végétaux ainsi que le mobilier et les accessoires.' },
      tile3: { description: 'Un plan de plantation pour vous guider dans la réalisation.' },
      tile4: { description: 'Une remise exclusive chez Leroy Merlin pour vos achats.' }
    },
    commit: {
      title: 'Pourquoi choisir HortusBox ?',
      tile1: { title: 'Gain d\'argent'    , description: 'Réalisez votre projet d\'aménagement extérieur avec un budget maîtrisé ' },
      tile2: { title: 'Gain de temps'     , description: 'Service 100% en ligne pour concevoir le jardin de vos rêves à l’aide d’un paysagiste.' },
      tile3: { title: 'Rendu réel'        , description: 'Projetez-vous dans le futur aménagement de votre jardin avant de vous lancer dans les dépenses.' },
      tile4: { title: '100% personnalisé' , description: 'Une proposition basée sur votre style et vos envies avec notre expertise.' }
    }
  }
}

export const constantes = K

export { partners }

export default {
  namespaced: true,
  state: {
    host: K.HostHortusBox,
    isPartner: false,
    style: styles.default,
    homeData: homes.default
  },
  getters: {
    appStyle: state => state.style,
    isPartner: state => state.isPartner,
    partnerId: state => {
      if (partners[state.host]) {
        return partners[state.host].id
      }
      return partners[K.HostHortusBox].id
    },
    host: state => state.host,
    homeData: state => state.homeData
  },
  mutations: {
    setHost (state, val) {
      state.host = val
      state.style = styles[val] || styles.default
      state.homeData = homes[val] || homes.default
    },
    setIsPartner (state, val) {
      state.isPartner = val
    }
  },
  actions: {
    async updateHost({commit}) {
      return new Promise((resolve) => {
        if (/vpaceschi/i.test(window.location.href)) {
          commit('setHost', K.HostVPaceschi)
          commit('setIsPartner', false)
        } else if (/leroymerlin/i.test(window.location.href)) {
          commit('setHost', K.HostLeroyMerlin)
          commit('setIsPartner', true)
        } else if (/jardiland/i.test(window.location.href)) {
          commit('setHost', K.HostJardiland)
          commit('setIsPartner', true)
        } else {
          commit('setHost', K.HostHortusBox)
          commit('setIsPartner', false)
        }
        resolve()
      })
    }
  }
}